import { PublicClientApplication, Configuration, LogLevel } from '@azure/msal-browser';

const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_ENTRA_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_ENTRA_TENANT_ID || 'common'}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      logLevel: import.meta.env.DEV ? LogLevel.Warning : LogLevel.Error,
      piiLoggingEnabled: false,
    },
  },
};

// Use openid/profile scopes — the ID token carries group claims for authorization.
// No custom API scope needed (avoids AADSTS500011 if "Expose an API" isn't configured).
export const loginScopes = {
  scopes: ['openid', 'profile'],
};

let _msalInstance: PublicClientApplication | null = null;
try {
  _msalInstance = new PublicClientApplication(msalConfig);
} catch (e) {
  console.warn('MSAL initialization failed:', e);
}

export const msalInstance = _msalInstance as PublicClientApplication;

export const isAuthConfigured = Boolean(
  import.meta.env.VITE_ENTRA_CLIENT_ID && import.meta.env.VITE_ENTRA_TENANT_ID
  && _msalInstance
);
